import { Record, List, Map } from 'immutable';
import { tFunctionType } from 'app/services/localization';

interface IProps {
  getName: (t: tFunctionType) => string;
  id: string;
  internalId: number;
}

/**
 * @property {number} internalId - The ID used to perform a search on the tutor search page.
 */
export class TeachingSkill extends Record<IProps>({
  getName: () => '',
  id: '',
  internalId: -1,
}) {}

export const BEGINNER = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.beginner.name'),
  id: 'beginner',
  internalId: 8,
});

export const BUSINESS = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.business.name'),
  id: 'business',
  internalId: 6,
});

export const EIKEN = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.eiken.name'),
  id: 'eiken',
  internalId: 14,
});

export const EXPERT = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.expert.name'),
  id: 'expert',
  internalId: 9,
});

export const IELTS = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.ielts.name'),
  id: 'ielts',
  internalId: 23,
});

export const JOB_INTERVIEW = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.job-interview.name'),
  id: 'job_interview',
  internalId: 16,
});

export const KIDS = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.kids.name'),
  id: 'kids',
  internalId: 7,
});

export const LETS_GO = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.lets-go.name'),
  id: 'lets_go',
  internalId: 13,
});

export const LEVEL_TEST = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.level-test.name'),
  id: 'level_test',
  internalId: 21,
});

export const MEDICAL = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.medical.name'),
  id: 'medical',
  internalId: 19,
});

export const SPEAKING_TEST = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.speaking-test.name'),
  id: 'speaking_test',
  internalId: 10,
});

export const TOEFL = new TeachingSkill({
  getName: (t) => t('enum.teaching-skill.toefl.name'),
  id: 'toefl',
  internalId: 22,
});

export const ALL_TEACHING_SKILLS = List([
  BEGINNER,
  BUSINESS,
  EIKEN,
  EXPERT,
  IELTS,
  JOB_INTERVIEW,
  KIDS,
  LETS_GO,
  LEVEL_TEST,
  MEDICAL,
  SPEAKING_TEST,
  TOEFL,
]);

export const TEACHING_SKILLS_BY_ID =
  Map(ALL_TEACHING_SKILLS.map((teachingSkill) => [teachingSkill.id, teachingSkill] as [string, TeachingSkill]));
